import { AppConfig } from "../config/models/config";

export function getAuthConfig(
  appConfig: AppConfig,
) {
  return appConfig.getAuth0Config();
}
